import { formatDate } from '@angular/common';
import { Component, Inject, LOCALE_ID } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EmployeeService } from '@core/services/employees/employee.service';
import { GlobalConstants } from '@environments/global-Variables';
import { Column } from '@shared/models/column-interface';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

@Component({
  selector: 'weaccess-on-boarding-employee',
  templateUrl: './on-boarding-employee.component.html',
  styleUrls: ['./on-boarding-employee.component.scss']
})
export class OnBoardingEmployeeComponent {

  globalConstants = GlobalConstants;
  listDetailCardToggle: boolean = false;
  createdTableData: any;
  allocatedTableData: any;
  similarIDTableData: any;
  newAllocatedID: any;
  personalDataForm!: FormGroup;
  hiringDatePickerConfig: any;
  createdAllocatedSubscription!: Subscription;
  deallocateSubscription!: Subscription;
  allocateSubscription!: Subscription;

  createdTableColumns: Array<Column> = [
    {
      columnDef: 'firstName',
      header: 'First Name',
      cell: (element: Record<string, any>) => `${element['firstName']}`
    },
    {
      columnDef: 'lastName',
      header: 'Last Name',
      cell: (element: Record<string, any>) => `${element['lastName']}`
    },
    {
      columnDef: 'employeeId',
      header: 'Employee ID',
      cell: (element: Record<string, any>) => `${element['employeeId']}`,
    },
    {
      columnDef: 'entityName',
      header: 'Entity Name',
      cell: (element: Record<string, any>) => `${element['entityName'] + this.globalConstants.DOMAIN_ID}`,
    }
  ];

  allocatedTableColumns: Array<Column> = [
    {
      columnDef: 'firstName',
      header: 'First Name',
      cell: (element: Record<string, any>) => `${element['firstName']}`
    },
    {
      columnDef: 'lastName',
      header: 'Last Name',
      cell: (element: Record<string, any>) => `${(element['lastName']).toString().trim().replaceAll('-', ' ')}`
    },
    {
      columnDef: 'hiringDate',
      header: 'Hiring Date',
      cell: (element: Record<string, any>) => `${element['hiringDate']}`,
    },
    {
      columnDef: 'entityName',
      header: 'Entity Name',
      cell: (element: Record<string, any>) => `${element['entityName'] + this.globalConstants.DOMAIN_ID}`,
    }
  ];


  constructor(
    private bsModalRef: BsModalRef,
    private fb: FormBuilder,
    private toastService: ToastrService,
    private employeeService: EmployeeService,
    @Inject(LOCALE_ID) public locale: string
  ) { }

  ngOnInit() {
    /** Personal data form declaration */
    this.personalDataForm = this.fb.group({
      firstName: [, [Validators.required]],
      lastName: [, [Validators.required]],
      hiringDate: [, [Validators.required]]
    });

    /** Hiring date configuration */
    this.hiringDatePickerConfig = Object.assign({},
      {
        showWeekNumbers: false,
        minDate: new Date(),
        maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
        dateInputFormat: 'MM/DD/YYYY'
      });
    this.getCreatedAndAllocatedIdDetails();
  }

  /** Close modal functionality implementation */
  onClose() {
    this.bsModalRef.hide();
  }

  /** Clipboard copy functionality implementation */
  onClipboardCopy(successful: boolean): void {
    if (successful) {
      this.toastService.success('', 'Copied to Clipboard');
    } else {
      this.toastService.error('', 'Copy to clipboard is not successful')
    }
  }

  /** Getting generate id button enable status */
  getBtnEnableStatus() {
    if (this.personalDataForm?.valid)
      return true;
    else
      return false;
  }

  /** Getting created and allocated id details list from API */
  getCreatedAndAllocatedIdDetails() {
    let reqParams = {
      firstName: '',
      lastName: '',
      pageNumber: 1
    }

    this.createdAllocatedSubscription = this.employeeService.getCreatedAndAllocatedIDDetails(reqParams).subscribe((createdAllocatedData: any) => {
      if (createdAllocatedData) {
        this.allocatedTableData = createdAllocatedData?.domainEntityAllocationItems;
        this.createdTableData = createdAllocatedData?.domainEntityItems;
      }
    })
  }

  /** Getting similarly allocated id details list from API */
  getAllocatedIdDetails() {
    let reqParams = {
      firstName: this.personalDataForm?.value['firstName'],
      lastName: (this.personalDataForm?.value['lastName']).toString().trim().replaceAll(' ', '-'),
      pageNumber: 1
    }

    this.createdAllocatedSubscription = this.employeeService.getCreatedAndAllocatedIDDetails(reqParams).subscribe((similarAllocatedData: any) => {
      if (similarAllocatedData) {
        this.similarIDTableData = similarAllocatedData?.domainEntityAllocationItems;
      }
    })
  }

  /** Generate Entity ID API service call implementation */
  generateEntityID() {
    let reqParams = {
      firstName: this.personalDataForm?.value['firstName'],
      lastName: (this.personalDataForm?.value['lastName']).toString().trim().replaceAll(' ', '-'),
      hiringDate: formatDate(new Date(this.personalDataForm?.value['hiringDate']), 'yyyy-MM-dd', this.locale)
    }

    this.allocateSubscription = this.employeeService.generateEntityName(reqParams, '').subscribe((generateEntityData: any) => {
      if (generateEntityData) {
        this.newAllocatedID = generateEntityData?.entityName + this.globalConstants.DOMAIN_ID;
        this.getCreatedAndAllocatedIdDetails();
      }
    })
  }

  /** Deallocate Entity ID API service call implementation */
  deallocateID() {
    let reqParams = {
      domainEntityAllocationId: ''
    }

    this.deallocateSubscription = this.employeeService.deallocateEntityAllocated('', reqParams).subscribe((deallocateData: any) => {
      if (deallocateData) {
        this.similarIDTableData = deallocateData?.domainEntityAllocationItems;
      }
    })
  }

  /** Hiring date validation functionality implementation */
  hiringDateEdit() {
    if (!(this.personalDataForm?.value['hiringDate'] >= new Date())) {
      let datePatchVal = {
        hiringDate: null,
      }
      this.personalDataForm.patchValue(datePatchVal);
      this.toastService.warning('Invalid Date');
    }
  }

}
